
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class EventCalendar extends Vue {
  public weekday = [1, 2, 3, 4, 5, 6, 0]
  public focus = this.today
  public selectedDate = this.today

  public get today (): string {
    const date = new Date()
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  }

  public get local (): string {
    return this.$i18n.locale
  }
  // TODO Events
}
